import { cn } from "@/lib/utils";
import { Grain } from "@/components/ui/Grain";

type AuroraFieldProps = {
  variant?: "full" | "soft" | "cta";
  className?: string;
};

/**
 * Živé světelné pole: 5 blade elementů (screen blend, blur), grain + vinětace.
 * 0 % keyframe = plný bloom. Dekorativní, vždy aria-hidden.
 */
export function AuroraField({ variant = "full", className }: AuroraFieldProps) {
  return (
    <div aria-hidden="true" className={cn("aurora", className)} data-variant={variant}>
      <span className="blade blade-a">
        <span className="blade-drift">
          <span className="blade-breath" />
        </span>
      </span>
      <span className="blade blade-b">
        <span className="blade-drift">
          <span className="blade-breath" />
        </span>
      </span>
      <span className="blade blade-c">
        <span className="blade-drift">
          <span className="blade-breath" />
        </span>
      </span>
      <span className="blade blade-d">
        <span className="blade-drift">
          <span className="blade-breath" />
        </span>
      </span>
      {(variant === "full" || variant === "cta") && (
        <span className="blade blade-e">
          <span className="blade-drift">
            <span className="blade-breath" />
          </span>
        </span>
      )}
      <Grain />
    </div>
  );
}
